export default __webpack_public_path__ + "static/media/gaoleguidebanner.d5590e12.png";